var constants = require('../constants');
var initialState = require('../initialState');

var dashboardReducer = function(state, action) {
    state = state || initialState;

    switch (action.type) {
        case constants.REQUEST_TOTAL_SCORES:
            return Object.assign({}, state, {
                isFetching: true
            });
        case constants.RECEIVE_TOTAL_SCORES:
            return Object.assign({}, state, {
                totalScores: action.data,
                isFetching: false
            });
        case constants.REQUEST_TOTAL_SCORES_ERROR:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.errors
            });
        case constants.REQUEST_MYQOL_SCORES:
            return Object.assign({}, state, {
                isFetching: true
            });
        case constants.RECEIVE_MYQOL_SCORES:
            return Object.assign({}, state, {
                myqolScores: action.data,
                isFetching: false
            });
        case constants.REQUEST_MYQOL_SCORES_ERROR:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.errors
            });
        case constants.REQUEST_LATEST_HPI:
            return Object.assign({}, state, {
                isFetching: true
            });
        case constants.RECEIVE_LATEST_HPI:
            return Object.assign({}, state, {
                latestHpi: action.data || initialState.latestHpi,
                isHpiSent: false,
                isFetching: false
            });
        case constants.REQUEST_LATEST_HPI_ERROR:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.errors
            });
        case constants.DASHBOARD_SET_ACTIVE_ITEMS:
            return Object.assign({}, state, {
                activeItems: action.activeItems,
                isSnapShot: action.isSnapShot
            });
        case constants.DASHBOARD_CLEAR_ACTIVE_ITEMS:
            return Object.assign({}, state, {
                activeItems: initialState.activeItems
            });
        case constants.SET_ALARM_SYMPTOM_RESPONSES:
            return Object.assign({}, state, {
                alarmSymptomResponses: action.data
            });
        case constants.DASHBOARD_CLEAR:
            return initialState;
        case constants.SEND_HPI_BEGIN:
            return Object.assign({}, state, {
                isFetching: true,
                isHpiSent: false
            });
        case constants.SEND_HPI_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                isHpiSent: true
            });
        case constants.SEND_HPI_FAILURE:
            return Object.assign({}, state, {
                isFetching: false
            });
        case constants.CLEAR_SEND_HPI_STATUS:
            return Object.assign({}, state, {
                isHpiSent: false
            });
        default:
            return state;
    }
}

module.exports = dashboardReducer;



// WEBPACK FOOTER //
// ./src/common/modules/dashboard/reducers/dashboard.js